'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = NotificationItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotificationItem(_ref) {
  var notification = _ref.notification,
      isArchivedPage = _ref.isArchivedPage,
      btnDestroy = _ref.btnDestroy,
      handleArchive = _ref.handleArchive,
      handleDecline = _ref.handleDecline,
      handleDestroy = _ref.handleDestroy,
      handlePublish = _ref.handlePublish,
      polyglot = _ref.polyglot,
      showEventModal = _ref.showEventModal;

  var item = null;
  switch (notification.action) {
    case 'activity.request':
      item = _react2.default.createElement(_components.NotificationActivityRequest, {
        polyglot: polyglot,
        btnDestroy: btnDestroy,
        isArchivedPage: isArchivedPage,
        handleArchive: handleArchive,
        handleDestroy: handleDestroy,
        handleDecline: handleDecline,
        handlePublish: handlePublish,
        notification: notification,
        showEventModal: showEventModal
      });
      break;
    case 'activity.published':
      item = _react2.default.createElement(_components.NotificationActivityPublished, (0, _extends3.default)({
        polyglot: polyglot,
        btnDestroy: btnDestroy,
        isArchivedPage: isArchivedPage,
        handleArchive: handleArchive,
        handleDestroy: handleDestroy
      }, notification));
      break;
    case 'activity.declined':
      item = _react2.default.createElement(_components.NotificationActivityDeclined, (0, _extends3.default)({
        polyglot: polyglot,
        btnDestroy: btnDestroy,
        isArchivedPage: isArchivedPage,
        handleArchive: handleArchive,
        handleDestroy: handleDestroy
      }, notification));
      break;
    default:

  }
  return _react2.default.createElement(
    'div',
    { className: 'notification-item' },
    item
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/NotificationItem.js
// module id = 2237
// module chunks = 0